// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bgWhatsapp_msnz3 {\n  background-color: #25d366;\n}\n.bgWhatsapp_msnz3:hover {\n    background-color: #1ea952 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgWhatsapp": "bgWhatsapp_msnz3"
};
module.exports = ___CSS_LOADER_EXPORT___;
